export class User {
    name: string;
    token: string;
    profile_pic!: string;
    user_group: string;

    constructor(name: string, token: string, user_group: string) {
        this.name = name;
        this.token = token;
        this.user_group = user_group;
    }
}